var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.172 0C23.7022 0 24.2107 0.210507 24.5857 0.585255L36.4137 12.4044C36.7891 12.7795 37 13.2884 37 13.8191V35.3333C37 37.9107 34.8689 40 32.24 40H7.76C5.13112 40 3 37.9107 3 35.3333V4.66667C3 2.08934 5.13112 0 7.76 0H23.172Z",
    fill: "#E94848"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1255_158068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1548 12.1381C35.4678 12.4537 35.2443 12.9902 34.7998 12.9902H29C26.4227 12.9902 24.0976 10.7233 24.0976 8.21031V2.20435C24.0976 1.75791 24.6382 1.53528 24.9526 1.85224L35.1548 12.1381Z",
    fill: "white",
    fillOpacity: 0.24,
    shapeRendering: "crispEdges"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0667 15.9902C15.2131 15.9902 14.5111 16.6922 14.5111 17.5458C14.5111 18.6069 15.1007 19.9243 15.7215 21.1625C15.2362 22.6816 14.6856 24.3096 13.9813 25.6833C12.5397 26.2489 11.2542 26.6693 10.4812 27.2923C10.4692 27.3046 10.4578 27.3176 10.4472 27.3312C10.1648 27.62 10 28.0133 10 28.4347C10 29.2883 10.702 29.9902 11.5556 29.9902C11.9718 29.9902 12.3736 29.8349 12.6639 29.5382C12.6739 29.5304 12.6837 29.5223 12.6931 29.5138C13.262 28.8345 13.9328 27.6021 14.5306 26.4757C15.9081 25.9338 17.3519 25.3824 18.7451 25.0513C19.7622 25.871 21.2336 26.4125 22.4444 26.4125C23.298 26.4125 24 25.7105 24 24.8569C24 24.0033 23.298 23.3013 22.4444 23.3013C21.4734 23.3013 20.0623 23.648 18.9833 24.0111C18.1088 23.1901 17.3053 22.1647 16.7278 21.075C17.1404 19.8038 17.6222 18.532 17.6222 17.5458C17.6222 16.6922 16.9203 15.9902 16.0667 15.9902ZM16.0667 16.9236C16.4158 16.9236 16.6889 17.1966 16.6889 17.5458C16.6889 18.0127 16.4389 18.8723 16.1493 19.7965C15.7624 18.8974 15.4444 18.0348 15.4444 17.5458C15.4444 17.1966 15.7175 16.9236 16.0667 16.9236ZM16.334 22.2465C16.8019 22.9907 17.3498 23.6832 17.9479 24.2979C17.0254 24.5501 16.1245 24.8733 15.2354 25.2118C15.6648 24.2426 16.0086 23.2368 16.334 22.2465ZM22.4444 24.2347C22.7936 24.2347 23.0667 24.5077 23.0667 24.8569C23.0667 25.2061 22.7936 25.4791 22.4444 25.4791C21.7435 25.4791 20.7472 25.1627 19.9507 24.7208C20.8649 24.4623 21.8625 24.2347 22.4444 24.2347ZM13.1597 27.0201C12.7223 27.8009 12.2875 28.5297 11.9833 28.8965C11.8794 28.9958 11.7412 29.0569 11.5556 29.0569C11.2064 29.0569 10.9333 28.7838 10.9333 28.4347C10.9333 28.2704 11.0032 28.1072 11.0986 28.002C11.4635 27.7196 12.2574 27.3812 13.1597 27.0201Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1255_158068",
    x: 22.0977,
    y: 1.70337,
    width: 15.2031,
    height: 15.2869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1255_158068"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1255_158068",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPdf);
export default __webpack_public_path__ + "static/media/ic-pdf.e5a92ac39c8d6a1848026804371f8718.svg";
export { ForwardRef as ReactComponent };